var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWlbCombinedGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_39",
    "data-name": "Group 39",
    viewBox: "0 0 150 34.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#014a62}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M300.183 23.911c-3.75 5.214-14.633 8.488-21.6 4.389-.089-.055-.179-.1-.26-.157a15.44 15.44 0 0 1-6.686-8.119l-.033-.259-.138-1.005s-.61-3.3-1.407-6.541c-.2-1.044-.35-1.861-.35-1.861a3.766 3.766 0 0 1-.114-.526 4.682 4.682 0 0 1 .236-2.5 4.622 4.622 0 0 1 2.538-2.136c.008 0 .008 0 .016-.008a6.314 6.314 0 0 1 1.92-.322h.008a4.333 4.333 0 0 1 3.489 1.68 4.936 4.936 0 0 1 .431.856 4.552 4.552 0 0 1 .285 1.005s.187.707.439 1.641c.683 3.384 1.635 6.871 1.635 6.871l.309.966.073.228.309.966s1.074 2.905 5.515 2.678 5.743-3.125 6.052-3.871a7.738 7.738 0 0 0-.073-3.424l-1.611-7.593s-1.074-3.95 1.228-5.732 6.743-1.413 7.735 1.861c.976 3.267 2.05 9.226 2.05 9.226s1.754 6.476-1.996 11.687z",
    className: "cls-1",
    "data-name": "Path 53",
    transform: "translate(-247.599 -.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M30.738 84.284c-.033.047-.065.1-.1.149-4.563 6.539-15.877 7.976-21.555 4.773S2.2 79.4 2.2 79.4.577 73.56.065 70.185s3.359-5.519 6.235-4.828 3.6 4.7 3.6 4.7l1.837 7.543a7.884 7.884 0 0 0 1.415 3.14c.6.549 3.05 2.661 7.182 1.06s3.847-4.671 3.847-4.671l-.13-.973-.033-.259-.138-1s-.61-3.3-1.407-6.539c-.2-1.044-.35-1.86-.35-1.86a3.766 3.766 0 0 1-.114-.526 4.68 4.68 0 0 1 .236-2.5 4.622 4.622 0 0 1 2.538-2.135c.008 0 .008 0 .016-.008A6.315 6.315 0 0 1 26.72 61h.008a4.333 4.333 0 0 1 3.489 1.68 4.933 4.933 0 0 1 .431.856 4.549 4.549 0 0 1 .285 1s.187.707.439 1.641c.683 3.383 1.635 6.869 1.635 6.869l.309.966.073.228a15.084 15.084 0 0 1-2.651 10.044z",
    className: "cls-1",
    "data-name": "Path 54",
    transform: "translate(-.018 -56.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M274.565 68.726a4.273 4.273 0 0 1-5.173-2.489 5.013 5.013 0 0 1 .236-2.595 4.671 4.671 0 0 1 2.538-2.212c.008 0 .008 0 .016-.008a5.911 5.911 0 0 1 .675-.2 5.063 5.063 0 0 1 1.245-.13h.008a4.281 4.281 0 0 1 3.489 1.741 3.2 3.2 0 0 1 .431.887l.073.26c.472 2.07-1.114 4.193-3.538 4.746z",
    className: "cls-1",
    "data-name": "Path 55",
    transform: "translate(-247.415 -56.124)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(65.708 1.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M783.382 32.5l-4.6 13.6h-1.049l-4.213-12.2-4.238 12.2h-1.049L763.6 32.5h1.049l4.14 12.241 4.255-12.241H774l4.238 12.258 4.176-12.258z",
    className: "cls-1",
    "data-name": "Path 56",
    transform: "translate(-763.6 -31.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M1010 79.149a4.826 4.826 0 1 1 4.815 5.149 4.826 4.826 0 0 1-4.815-5.149zm8.7 0c0-2.546-1.659-4.27-3.872-4.27s-3.872 1.733-3.872 4.27 1.659 4.27 3.872 4.27 3.872-1.724 3.872-4.27z",
    className: "cls-1",
    "data-name": "Path 57",
    transform: "translate(-989.958 -69.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M1162.231 74v.952c-.1 0-.2-.016-.3-.016-2.928 0-4.669 1.5-4.669 4v5.287H1156V74.081h1.212v2.212c.797-1.471 2.546-2.293 5.019-2.293z",
    className: "cls-1",
    "data-name": "Path 58",
    transform: "translate(-1124.083 -69.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M1229.818 31.4l-2.936 2.408v3.01h-1.082V22.4h1.082v10.2l7.2-5.921h1.383l-4.856 4.1 5.328 6.043h-1.337z",
    className: "cls-1",
    "data-name": "Path 59",
    transform: "translate(-1188.205 -22.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M1346.7 32.5h1.139v12.705h9v.895H1346.7z",
    className: "cls-1",
    "data-name": "Path 60",
    transform: "translate(-1299.271 -31.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    d: "M1470.3 30.156a.756.756 0 0 1 1.513 0 .756.756 0 0 1-1.513 0zm.269 2.953h.968v10.143h-.968z",
    className: "cls-1",
    "data-name": "Path 61",
    transform: "translate(-1412.818 -28.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    d: "M1491.306 24.371v1.48h3.245v.838h-3.221v9.305h-.968v-9.305h-1.862v-.838h1.863V24.3a2.586 2.586 0 0 1 2.814-2.8 3.027 3.027 0 0 1 2 .659l-.39.74a2.333 2.333 0 0 0-1.57-.561c-1.268 0-1.911.699-1.911 2.033z",
    className: "cls-1",
    "data-name": "Path 62",
    transform: "translate(-1429.538 -21.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M1552.553 79.385h-9.069a4.179 4.179 0 0 0 4.466 4.043 4.339 4.339 0 0 0 3.375-1.415l.586.643a5.495 5.495 0 0 1-9.411-3.5 5.04 5.04 0 1 1 10.078-.049 2.75 2.75 0 0 0-.025.278zm-9.053-.756h8.085a4.053 4.053 0 0 0-8.085 0z",
    className: "cls-1",
    "data-name": "Path 63",
    transform: "translate(-1479.145 -69.73)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(.26 13.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M778.789 226.809l-2.058-1.944a6.873 6.873 0 0 1-4.954 1.846c-2.9 0-4.978-1.4-4.978-3.457 0-1.61 1.017-2.8 3.725-4.238-1.44-1.358-1.863-2.18-1.863-3.221 0-1.732 1.464-2.9 3.75-2.9 2.1 0 3.449 1.009 3.449 2.7 0 1.358-.887 2.31-3.3 3.6l4.067 3.847a7.963 7.963 0 0 0 .992-2.619l1.228.35a9.136 9.136 0 0 1-1.309 3.132l2.115 2zm-2.945-2.782l-4.465-4.213c-2.375 1.244-3.091 2.1-3.091 3.3 0 1.48 1.44 2.448 3.579 2.448a5.376 5.376 0 0 0 3.978-1.535zm-5.783-8.256c0 .8.317 1.358 1.676 2.619 2.139-1.131 2.839-1.806 2.839-2.782 0-1.009-.781-1.692-2.164-1.692-1.48.009-2.35.765-2.35 1.855z",
    className: "cls-1",
    "data-name": "Path 64",
    transform: "translate(-766.8 -212.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M950.047 224.007c0 2.334-1.969 3.693-5.751 3.693H937v-13.6h6.881c3.522 0 5.417 1.383 5.417 3.538a3.236 3.236 0 0 1-1.887 2.993 3.383 3.383 0 0 1 2.636 3.376zm-10.322-7.931v3.75h3.863c1.887 0 2.961-.618 2.961-1.863 0-1.261-1.074-1.887-2.961-1.887zm7.573 7.678c0-1.358-1.114-1.96-3.172-1.96h-4.409v3.921h4.409c2.057 0 3.174-.602 3.174-1.96z",
    className: "cls-1",
    "data-name": "Path 65",
    transform: "translate(-923.156 -213.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M1111.823 258.376h-8.955c.317 1.513 1.708 2.489 3.7 2.489a4.28 4.28 0 0 0 3.1-1.131l1.432 1.5a6.085 6.085 0 0 1-4.6 1.692c-3.823 0-6.3-2.237-6.3-5.319s2.5-5.3 5.9-5.3c3.335 0 5.767 2.115 5.767 5.36-.003.188-.027.481-.044.709zm-8.979-1.611h6.474a3.02 3.02 0 0 0-3.229-2.522 3.079 3.079 0 0 0-3.245 2.523z",
    className: "cls-1",
    "data-name": "Path 66",
    transform: "translate(-1073.082 -248.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M1241.94 253.608l-4.856 11.208c-.952 2.351-2.269 3.066-4 3.066a4.311 4.311 0 0 1-2.782-.952l.968-1.789a2.629 2.629 0 0 0 1.789.716c.854 0 1.358-.407 1.83-1.44l.171-.407-4.531-10.411h2.521l3.262 7.67 3.286-7.67h2.343z",
    className: "cls-1",
    "data-name": "Path 67",
    transform: "translate(-1192.6 -249.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M1365.2 257.6c0-3.107 2.611-5.3 6.182-5.3 3.611 0 6.2 2.2 6.2 5.3s-2.587 5.319-6.2 5.319c-3.571.004-6.182-2.209-6.182-5.319zm9.639 0a3.455 3.455 0 1 0-3.457 3.245 3.2 3.2 0 0 0 3.457-3.245z",
    className: "cls-1",
    "data-name": "Path 68",
    transform: "translate(-1316.527 -248.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M1537.825 256.847v5.946h-2.432v-5.637c0-1.846-.911-2.741-2.465-2.741-1.732 0-2.9 1.049-2.9 3.132v5.246h-2.428v-10.379h2.31v1.342a4.507 4.507 0 0 1 3.571-1.456c2.497 0 4.344 1.415 4.344 4.547z",
    className: "cls-1",
    "data-name": "Path 69",
    transform: "translate(-1465.717 -248.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M1675.422 204v14.413h-2.334v-1.342a4.27 4.27 0 0 1-3.441 1.48 5.312 5.312 0 0 1 0-10.623 4.258 4.258 0 0 1 3.343 1.4V204zm-2.392 9.232a3.095 3.095 0 1 0-3.091 3.245 3.032 3.032 0 0 0 3.091-3.245z",
    className: "cls-1",
    "data-name": "Path 70",
    transform: "translate(-1591.39 -204)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlbCombinedGreen);
export default __webpack_public_path__ + "static/media/wlb-combined-green.9a7c1fc6a773cecdd665c241773f2a62.svg";
export { ForwardRef as ReactComponent };